import { cva } from 'class-variance-authority';

export const cvaCardContainer = cva([
  'payments-payg-styles-cvaCardContainer',
  'bg-general_MI_800_disabled',
  'rounded-[1rem]',
  'shadow-[0px_4px_40px_0px_rgba(0,0,0,0.24)]',
  'relative',
  'px-8 py-[4.75rem]',
  'flex',
  'flex-col',
  'gap-6',
  'overflow-hidden',
]);

export const cvaTitleContainer = cva([
  'ff-inter',
  'payments-payg-styles-cvaTitleContainer',
  'flex',
  'flex-col',
  'items-center',
  'text-center',
  'relative',
  'z-[4]',
]);

export const cvaTitle = cva([
  'payments-payg-styles-cvaTitle',
  'text-font_ds_title_title_title_32',
  'text-general_text_MII_default',
  'mb-1',
]);

export const cvaSubtitle = cva([
  'payments-payg-styles-cvaSubtitle',
  'font_ds_title_body_body_14',
  'text-general_text_MII_secondary_ii',
  'mb-3',
]);

export const cvaProgressContainer = cva([
  'payments-payg-styles-cvaProgressContainer',
  'relative',
  'h-[1.375rem]',
  'border border-solid border-general_MI_700_pressed',
  'rounded-[2.5rem] w-full',
]);

export const cvaProgressBackground = cva([
  'payments-payg-styles-cvaProgressBackground',
  'absolute',
  'inset-0',
  'bg-general_MI_800_disabled',
  'rounded-[10.5px]',
  'border',
  'border-general_MI_700_pressed',
]);

export const cvaProgressFill = cva([
  'payments-payg-styles-cvaProgressFill',
  'absolute',
  'inset-y-0',
  'left-0',
  'rounded-[10.5px]',
  'bg-gradient-to-r',
  'from-[#00543D]',
  'to-general_MI_500_default',
]);

export const cvaHelpContainer = cva([
  'payments-payg-styles-cvaHelpContainer',
  'flex',
  'flex-col',
  'gap-3',
  'items-center',
  'relative',
  'z-[3]',
]);

export const cvaHelpText = cva([
  'ff-inter',
  'payments-payg-styles-cvaHelpText',
  'text-font_ds_title_body_body_14',
  'text-general_text_MII_secondary_ii',
  'text-center',
]);

export const cvaContactButton = cva(['payments-payg-styles-cvaContactButton', 'px-6']);

export const cvaGradientTop = cva([
  'payments-payg-styles-cvaGradientTop',
  'absolute',
  'left-1/2',
  '-translate-x-1/2',
  'top-[-215px]',
  'size-[430px]',
  'pointer-events-none',
  'z-[1]',
]);

export const cvaGradientBottom = cva([
  'payments-payg-styles-cvaGradientBottom',
  'absolute',
  'left-1/2',
  '-translate-x-1/2',
  'bottom-[-384px]',
  'size-[430px]',
  'pointer-events-none',
  'z-[2]',
]);
